import axios from 'axios';
import store from 'store';

const state = {
  claimsFilter: [],
  clusterUsers: {},
  filterTemplates: [],
  salesFilter: [],
};

const getters = {};

const mutations = {
  setClaimsFilter: (st, payload) => {
    st.claimsFilter = payload;
  },
  setClusterUsers: (st, payload) => {
    st.clusterUsers = payload;
  },
  setFilterTemplates: (st, payload) => {
    st.filterTemplates = payload;
  },
  setSalesFilter: (st, payload) => {
    st.salesFilter = payload;
  },
};

const actions = {
  getClusterUsers: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      if (store.get('permissions').indexOf('clusters.users.index') >= 0) {
        axios
          .get(`clusters/users/filter?paginated=false`)
          .then(res => {
            commit('setClusterUsers', res.data.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
      if (store.get('permissions').indexOf('leads.index') >= 0) {
        axios
          .get(`clusters/users/sales/filter`)
          .then(res => {
            commit('setSalesFilter', res.data.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
      if (store.get('permissions').indexOf('claims.index') >= 0) {
        axios
          .get(`clusters/users/claims/filter`)
          .then(res => {
            commit('setClaimsFilter', res.data.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
      dispatch('getFilterTemplates');
      resolve();
    });
  },
  getFilterTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`clusters/users/filters?paginated=false`)
        .then(res => {
          commit('setFilterTemplates', res.data.data);
          resolve();
        })
        .catch(() => {
          reject();
        });
      resolve();
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/clusterUsers.js